export enum LoadingState {
  IDLE = 'idle',
  PENDING = 'pending',
  FULFILLED = 'fulfilled',
  REJECTED = 'rejected'
}

export enum SortOptions {
  RECOMMENDED = 'relevance',
  PRICE_ASC = 'price-asc',
  PRICE_DESC = 'price-desc',
  NEW = 'new'
}

export enum ProductStatus {
  PUBLISHED = '40-GEPUB',
  NOT_PUBLISHED = '45-NI-GE',
  END_OF_LIFE_PRODUCT = '50-EOL',
  END_OF_LIFE_LINE = '99-EOL',
  FREE = '10-VRIJ'
}

export interface ApiResponse {
  count?: number;
  total?: number;
  timing?: Timing;
  pagination?: Pagination;
  active?: any[];
  facets?: Facet[];
  sort?: SortItem[];
  options?: Options;
  results?: ApiProduct[];
  categories?: Category[];
  correctedAttributes?: boolean;
}

export interface ApiProduct {
  code: string;
  title: string;
  visible?: boolean;
  status: string;
  displayOrder?: number;
  description: string;
  mainCategoryId?: number;
  url?: string;
  variantOptions: Attribute[];
  variants: Variant[];
  defaultVariantCode: string;
  attributes?: { [key: string]: Attribute };
  symbols?: ProductSymbol[];
  labels?: any[];
  files?: File[];
  videos?: any[];
  categories?: number[];
  displayOrders?: { [key: string]: number };
  storeViews?: string[];
  sectors?: Sector[];
  dateImported?: Date;
  relatedProducts?: string[];
  media?: Media[];
}

export interface VariantAttributeValue {
  code: string;
  value: string;
  image?: string;
  url?: string;
  disabled?: boolean;
}

export interface SelectableVariantAttribute {
  type: string;
  code: string;
  name: string;
  values: VariantAttributeValue[];
}

export interface UniqueSellingPoint {
  code: string;
  value: string;
}
export interface MappedProduct extends Omit<ApiProduct, 'variants' | 'variantOptions' | 'symbols'> {
  // selectableVariantAttributes: { [key: string]: Array<{ code: string; value: string }> }[];
  selectableVariantAttributes: SelectableVariantAttribute[];
  variants: MappedVariant[];
  symbols?: MappedProductSymbol[];
  uniqueSellingPoints?: UniqueSellingPoint[];
  technicalData?: MappedTechnicalData[];
}

export interface MappedResponse extends Omit<ApiResponse, 'results'> {
  results: MappedProduct[];
}

export interface Category {
  code: string;
  parentCode?: string;
  name: string;
  selected?: boolean;
  urlSet: URLSet;
  childCodes: string[];
  isRoot?: boolean;
  isStoreview?: boolean;
}

export interface Facet {
  type: TypeClass;
  items: FacetItem[];
}

export interface FacetItem {
  value: TypeClass;
  hits: number;
  urlSet: URLSet;
  selected?: boolean;
}

export type FacetsDictionary = { [key: string]: string[] }[];

export interface URLSet {
  web: string;
  api: string;
  canonical?: string;
  rel?: string;
  noIndex?: boolean;
  invalid?: boolean;
}

export interface TypeClass {
  code: string;
  value: string;
  displayOrder: number;
}

export interface Options {
  skip?: number;
  take?: number;
  searchTerm?: string;
  sortBy?: string;
  boundry?: number;
  includeHiddenLines?: boolean;
  visible?: boolean;
  status?: string[];
  context?: number;
  webPrefix?: string;
  includeContent?: boolean;
}

export interface Pagination {
  relative: Relative;
  items: PaginationItem[];
}

export interface PaginationItem {
  code: string;
  label?: string;
  urlSet: URLSet;
  selected: boolean;
  isSeparator?: boolean;
}

export interface Relative {
  self?: PaginationItem;
  first?: PaginationItem;
  last?: PaginationItem;
  next?: PaginationItem;
  prev?: PaginationItem;
}

export interface Attribute {
  type: TypeClass;
  items: ProductSymbol[];
}

export interface ProductSymbol {
  code: TypeClass;
  value: TypeClass;
  url: string;
  images: Image[];
  image: string;
}
export interface MappedProductSymbol {
  code: string;
  image: string;
  url: string;
  value: string;
}

export interface MappedTechnicalData {
  code: string;
  image?: string;
  name: string;
  value: string;
}

interface Media {
  type?: string;
  thumbnail?: string;
  description?: string;
  src: string;
  modified?: Date;
  languageCode?: string;
  alt?: string;
  imageData?: {
    height: number;
    width: number;
  };
}

export interface Image {
  type: string;
  src: string;
  modified?: Date;
  imageData?: ImageData;
}

export interface ImageData {
  width: number;
  height: number;
}

export interface File {
  type?: string;
  description?: string;
  src?: string;
  modified?: Date;
  languageCode?: string;
  fileTypeCode?: string;
}

export type Sector = 'facility' | 'industry' | 'food' | 'medical';

export interface Variant {
  code: string;
  productCode: string;
  title: string;
  url: string;
  media: Image[];
  optionCode1?: string;
  optionCode2?: string;
  lineSequence?: number;
  visible?: boolean;
  status?: string;
  unitsOfMeasure: UnitOfMeasure[];
  imageName?: string;
}

export interface MappedAttribute {
  code: string;
  value: string;
  url?: string;
  image?: string;
}

export type VariantAttributes = Record<string, string>;
export interface MappedVariant extends Omit<Variant, 'optionCode1' | 'optionCode2'> {
  variantAttributes: VariantAttributes;
}

export interface UnitOfMeasure {
  code: string;
  description: string;
  eanCode?: string;
  itemsPerUnit: number;
  name: string;
  prices: Prices;
  unuom?: string;
  visible?: boolean;
}

export interface Prices {
  variantCode: string;
  unitOfMeasureCode: string;
  current: Current;
  old: Current;
  discount?: number;
  quantityPer?: number;
}

export interface Current {
  exTax: Tax;
  incTax: Tax;
}

export interface Tax {
  numeric: number;
  formatted: string;
}

export interface SortItem {
  code: string;
  value: string;
  urlSet: URLSet;
  selected?: boolean;
}

export interface Timing {
  'Solr.Prepare'?: number;
  'Solr.Query'?: number;
  'Process.Facets'?: number;
  'Process.Pagination'?: number;
  'Process.Sort'?: number;
  'Process.Results'?: number;
  Total?: number;
}
